<template>
  <div>
    <div class="modal-container" @keydown.esc="closetModal()">
      <form class="px-4 py-5 modal-content filter-table">
        <div class="d-flex justify-content-between">
          <h2 class="text-capitalize pb-4 px-2 mb-0 header">
            Load Saved Demographic
          </h2>
          <div class="cursor-pointer">
            <span @click="closetModal()"> <close-svg /> </span>
          </div>
        </div>
        <div>
          <input
            class="survey-title px-4 text-capitalize"
            placeholder="Search"
            type="text"
            v-model="filterQuestions"
          />
        </div>

        <!-- filter  -->
        <filter-ui>
          <template v-slot:title> Filter by Group </template>
          <template v-slot:filterOptions>
            <div
              v-for="(group, index) in surveyGroupOptions"
              :key="group + index"
            >
              <input
                class="d-none filter-option"
                type="radio"
                :id="group.id"
                :value="group.id"
                v-model="selectedGroup"
              />
              <label
                class="me-2 text-capitalize filter-button px-3"
                :for="group.id"
                >{{ group.name }}</label
              >
            </div>
          </template>
          <template v-slot:clearOption>
            <transition name="fade">
              <div @click="selectedGroup = 'clear'">
                <clear-button></clear-button>
              </div>
            </transition>
          </template>
        </filter-ui>
        <!-- ./filter  -->

        <div
          class="mb-5 text-info overflow-auto pe-4 table-content accordion"
          id="accordionExample"
        >
          <table class="w-100">
            <thead>
              <tr class="main-row">
                <td class="outer-td py-2 w-100">
                  <table class="w-100">
                    <tr class="text-capitalize">
                      <th class="index-cell">No.</th>
                      <th>Name</th>
                      <th class="description-cell">Question description</th>
                      <td class="index-cell"></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(demoQuestion, index) in filteredRows"
                :key="`employee-${index}`"
                class="outer-row"
              >
                <td class="outer-td py-2">
                  <table class="w-100">
                    <tr>
                      <td>
                        <div class="d-flex align-items-center">
                          <input
                            type="checkbox"
                            :id="'demoQuestion-' + index"
                            :value="demoQuestion.id"
                            v-model="checkedIds"
                            class="d-none"
                            ref="checkboxs"
                          />
                          <label
                            :for="'demoQuestion-' + index"
                            class="w-100 d-block"
                          >
                            <table
                              class="w-100 info-table"
                              :class="{
                                'active-row': checkedIds.includes(
                                  demoQuestion.id
                                ),
                              }"
                            >
                              <tr>
                                <td class="index-cell">{{ index + 1 }}</td>
                                <td
                                  v-html="
                                    highlightMatches(
                                      demoQuestion.localizations['EN'].name
                                    )
                                  "
                                ></td>
                                <td
                                  v-if="
                                    !demoQuestion.localizations[
                                      'EN'
                                    ].description.includes('{')
                                  "
                                  class="description-cell"
                                  v-html="
                                    highlightMatches(
                                      demoQuestion.localizations['EN']
                                        .description
                                    )
                                  "
                                ></td>
                                <td v-else class="description-cell">
                                  <span
                                    v-html="
                                      highlightMatches(
                                        demoQuestion.localizations[
                                          'EN'
                                        ].description.split('${')[0]
                                      )
                                    "
                                  ></span>

                                  <span
                                    v-html="
                                      highlightMatches(
                                        questionPlaceholderValue(
                                          demoQuestion.localizations['EN']
                                            .description
                                        )
                                      )
                                    "
                                  ></span>

                                  <span
                                    v-html="
                                      highlightMatches(
                                        demoQuestion.localizations[
                                          'EN'
                                        ].description.split('}')[1]
                                      )
                                    "
                                  ></span>
                                </td>
                                <td class="index-cell">
                                  <button
                                    class="accordion-button collapsed px-0"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    :data-bs-target="
                                      '#collapse' + demoQuestion.code
                                    "
                                    aria-expanded="true"
                                    :aria-controls="
                                      'collapse' + demoQuestion.code
                                    "
                                  ></button>
                                </td>
                              </tr>
                              <div class="position-absolute right-sign">
                                <img
                                  class="img-fluid"
                                  alt="selected"
                                  src="@/assets/images/create-survey/right_sign.svg"
                                />
                              </div>
                            </table>
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          :id="'collapse' + demoQuestion.code"
                          class="accordion-collapse collapse"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body px-0">
                            <ul class="row list-unstyled m-0">
                              <li
                                class="col-4 answers my-1"
                                v-for="item in demoQuestion.choices"
                                :key="'answer-' + item.code"
                              >
                                {{ item.localizations["EN"].localizedChoice }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-center">
          <button class="border-0 btn-start" @click.prevent="letsGo()">
            <a class="text-capitalize py-3 px-5 d-block">let's go!</a>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TableSearchManager from "@/manager/TableSearchManager";
import { mapGetters } from "vuex";
import PlaceholderManager from "@/manager/placeholderManager";

export default {
  name: "LoadAllDemographicQuestion",
  inject: ["allPlaceholders"],
  data() {
    return {
      checkedIds: [],
      filterQuestions: "",
      selectedGroup: "clear",
    };
  },
  computed: {
    ...mapGetters("surveyJourney", {
      allDemographicQuestionsDataset: "getDemographicQuestionsDataset",
      surveyGroupOptions: "customerGroupsDataset",
    }),

    filteredRows() {
      return TableSearchManager.filteredDemoQuestionRows(
        this.DemographicQuestions,
        this.filterQuestions
      );
    },

    allPlaceholder() {
      return this.allPlaceholders();
    },

    DemographicQuestions() {
      let filterdQuestions = [];

      const targetGroup = this.surveyGroupOptions.find(
        (group) => group.id === this.selectedGroup
      );

      if (this.selectedGroup === "clear") {
        filterdQuestions = this.allDemographicQuestionsDataset;
      } else if (this.selectedGroup !== "clear" && targetGroup) {
        filterdQuestions = targetGroup.demographicQuestions;
      }

      return filterdQuestions;
    },
  },
  methods: {
    closetModal() {
      this.$emit("hide-modal");
    },

    letsGo() {
      const selectedQuestions = [];
      this.checkedIds.forEach((id) => {
        selectedQuestions.push(this.filteredRows.filter((q) => q.id === id)[0]);
      });
      this.$emit("add-questions-event", selectedQuestions);
      this.closetModal();
    },

    highlightMatches(text) {
      return TableSearchManager.highlightMatches(text, this.filterQuestions);
    },

    questionPlaceholderKey(questionDescription) {
      return PlaceholderManager.questionPlaceholderKey(questionDescription);
    },

    questionPlaceholderValue(questionDescription) {
      return PlaceholderManager.questionPlaceholderValue(
        this.allPlaceholder,
        this.questionPlaceholderKey(questionDescription)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  min-width: 1200px;
}

table {
  td,
  th {
    width: 200px;
  }
  .index-cell {
    width: 50px;
  }

  .description-cell {
    width: 21.875rem;
  }
}

::-webkit-scrollbar {
  height: 5px;
}

.answers:after {
  width: 15px;
  height: 15px;
  left: 10px;
}
</style>
